module.exports = __webpack_public_path__ + "static/media/arrowUpIcon.cbfbd1de.svg";